import { initSentry } from './sentry'
import { initDatadog } from './datadog'

export const initServices = () => {
  initSentry()
  initDatadog()
}
